/* eslint-disable @typescript-eslint/no-explicit-any */
import style from './Modify.module.less';
import AnalysisHeader from '@pages/layout/components/AnalysisHeader';
import {usePageState, useRouter} from '@hooks/hooks';
import {Button, Input, Pagination, Popover, Select, Table} from 'antd';
import React, {useState} from 'react';
import {courseOtherRecord, courseRecord, schoolAreaRecord} from '@/utils/const';
import IconFont from '@/common/IconFont';
import Wrapper from '@/common/wrapper/Wrapper';
import {getColumns} from './const';
import {ColumnType} from '@pages/mana/components/Table';
import {getExamStudentScores, modifyExamStudentScores} from '@/service/exam/modifyScore';

const ModifyScore = () => {
  const router = useRouter();
  const state = usePageState<any, any>();
  const { examId } = router.getEncodeParams();
  const { archive } = router.getSearchParams();
  const name = router.getZnInParams(router.getParams().examId);
  const [scoreList, setScoreList] = useState<ExamStudentScore[]>([]);
  const areaList = Object.entries(schoolAreaRecord).map(([key, value]) => {
    return {
      label: value,
      value: key
    };
  });
  const [column, setColumn] = useState<ColumnType<ExamStudentScore>[]>([]);

  const setDataFn = (result: unknown , field: string, id: number, course?:ScoreCourseStu) => {
    setScoreList((origin) => {
      const baseData = JSON.parse(JSON.stringify(origin));
      let data = baseData.find((el:ExamStudentScore) => el.studentId === id);
      let modifyData = data?.examCourseStudentList.find((el:ScoreCourseStu) => el.coursetypeDcode === course?.coursetypeDcode);
      if (modifyData) {
        modifyData[field] = result;
      }
      return baseData;
    });
  };

  const popValueChange = (val: string, id: number, course?:ScoreCourseStu) => {
    let value = val.replace(/[^\d.]/g,'');
    value = value.replace(/^\./g,'');
    value = value.replace(/^[0][0]/g,'0');
    value = value.replace(/\.{2,}/g,'.');
    value = value.replace('.','$#$').replace(/\./g,'').replace('$#$','.');
    value = value.replace(/^(-)*(\d+)\.(\d).*$/,'$1$2.5');
    setDataFn(value, 'score', id, course);
  };

  const saveScore = async (id: number, course?:ScoreCourseStu) => {
    const isHaveModule = Object.entries(courseOtherRecord).find(([key]) => key === course?.coursetypeDcode);
    let data:ScoreModifyParam = {
      studentId: id,
      examId: Number(examId),
      score: course?.score ? Number(course?.score): ''
    };
    if (course?.examCourseId) {
      data.examCourseId = course.examCourseId;
    }
    if (course?.examCourseStudentId) {
      data.examCourseStudentId = course.examCourseStudentId;
    }
    if (isHaveModule) {
      data.scoreModuleType = course?.coursetypeDcode;
    }
    modifyExamStudentScores(data).then((res) => {
      if (res.data) {
        setScoreList((origin) => {
          const baseData = JSON.parse(JSON.stringify(origin));
          let changeData = baseData.find((el:ExamStudentScore) => el.studentId === id);
          let modifyData = changeData?.examCourseStudentList.find((el:ScoreCourseStu) => el.coursetypeDcode === course?.coursetypeDcode);
          if (modifyData) {
            modifyData.originalScoreTotal = data.score;
            modifyData.open = false;
          }
          let count = 0;
          let isNull = true;
          changeData?.examCourseStudentList.forEach((el: ScoreCourseStu) => {
            if (el.originalScoreTotal || el.originalScoreTotal === 0) {
              isNull = false;
              count += Number(el.originalScoreTotal);
            }
          });
          changeData.originalScoreTotal = isNull ? null: count;
          return baseData;
        });
      }
    });
  };

  const loadFn = async (params: ExamScoreParam) => {
    if (params.examCardNumberLike && params.examCardNumberLike.length >= 4 || params.studentNameLike && params.studentNameLike.length >= 2) {
      const {data} = await getExamStudentScores({...params, examId: Number(examId)});
      const list = data.dataList.map(el => {
        return {
          ...el,
          examCourseStudentList: el.examCourseStudentList.map(cl => {return {...cl, open: false, score: cl.originalScoreTotal};})
        };
      });
      setScoreList(list);
      state.setTotal(data.totalCount);
      if (data.dataList.length > 0) {
        let base = getColumns();
        const first = data.dataList[0];
        first.examCourseStudentList.forEach(el => {
          const record = {...courseRecord, ...courseOtherRecord};
          const str:ColumnType<ExamStudentScore> = {
            title: record[el.coursetypeDcode],
            render: (_,p) => {
              const result = p.examCourseStudentList.find(fl => fl.coursetypeDcode === el.coursetypeDcode);
              return (<>
                <span>{result && result.originalScoreTotal}
                  <Popover
                    content={
                      <>
                        <div className={style.popInputWrapper}>
                          <span>{record[el.coursetypeDcode]}：</span>
                          <Input style={{width: '88px'}} defaultValue={result?.originalScoreTotal} value={result?.score} onChange={e => popValueChange(e.target.value, p.studentId, result)}/>
                        </div>
                        <div className={style.popBtnWrapper}>
                          <Button onClick={() => {setDataFn(result?.originalScoreTotal, 'score', p.studentId, result);setDataFn(false, 'open', p.studentId, result);}}>取消</Button>
                          <Button type="primary" onClick={() => saveScore(p.studentId, result)}>保存</Button>
                        </div>
                      </>
                    }
                    trigger="click"
                    visible={result?.open}
                    onVisibleChange={(e) => {setDataFn(e, 'open', p.studentId, result);setDataFn(result?.originalScoreTotal, 'score', p.studentId, result);}}
                  >
                    <IconFont type="icon-xiugai" className={`${archive=== 'true' ? style.hide : style.modifyIcon}`}></IconFont>
                  </Popover>
                </span>
              </>);
            }
          };
          base.push(str);
        });
        setColumn(base);
      }
    } else {
      setScoreList([]);
    }
  };

  // 分页变化
  const pageChange = (pageNum: number, pageSize: number) => {
    const newParams = {
      ...state.params,
      pageNum, pageSize
    };
    state.setParams(newParams);
    loadFn(newParams);
  };

  const setParamsValue = (fieldName: string, value: any) => {
    const newParams = { ...state.params, [fieldName]: value };
    state.setParams(newParams);
    loadFn(newParams);
  };

  const toHistory = () => {
    router.to('/front/examCenter/modifyHistory' + `?examName=${decodeURI(name)}&examId=${examId}`);
  };

  return (
    <div className={style.wrapper}>
      <AnalysisHeader
        title={['考试分析', decodeURI(name), '修改成绩']}
      />
      <div className={style.content}>
        <div className={style.search}>
          <div>
            <Select
              key="schoolareaDcode"
              placeholder="全部片区"
              style={{width: '100px'}}
              onChange={e => setParamsValue('schoolareaDcode', e)}
              allowClear
            >
              {
                areaList.map(j => <Select.Option key={j.value}>{j.label}</Select.Option>)
              }
            </Select>
            <Input
              key="studentNameLike"
              placeholder="学生姓名"
              style={{width: '220px'}}
              maxLength={30}
              onChange={e => {setParamsValue('studentNameLike', e.target.value);}}
              suffix={
                <IconFont type="icon-sousuo"></IconFont>
              }
            />
          </div>
          <Button onClick={toHistory}>修改记录</Button>
        </div>
        <Wrapper>
          <div className={`${style.tableEmpty} ${scoreList.length > 0 ? style.hide : ''}`}>
            <img src={require('@/assets/imgs/table-empty.png')} alt=""></img>
            <div>请先搜索需要修改成绩的学生</div>
          </div>
          <div className={`${scoreList.length === 0 ? style.hide : ''}`}>
            <Table
              columns={column}
              dataSource={scoreList}
              rowKey={r => r.id}
              pagination={false}
            />
            <div className={`${style.pagination}`}>
              <div>共<span>{state.total}</span>条数据</div>
              <Pagination
                showQuickJumper
                showSizeChanger
                pageSizeOptions={[10, 20, 50]}
                total={state.total}
                onChange={pageChange}
                current={state.params.pageNum}
                pageSize={state.params.pageSize}
              />
            </div>
          </div>

        </Wrapper>
      </div>
    </div>
  );
};
export default ModifyScore;
